<template>
	<div class="form-group clearfix">
		<div
			:class="{'float-left': (field.labelStyle=='justify'||field.labelStyle=='inline')}"
		>
			<label v-if="field.question" class="mr-2 align-top">
				{{ field.question }}
				<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
			</label>
            <small 
                v-if="requiredIncomplete"
                class="ml-1" style="color:#FF0000"    
            >
                {{  $t('required')}}
            </small>
			<div v-if="field.description" v-html="field.description" class="mr-2"></div>
			<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
		</div>
		<input
			type="text"
			class="form-control"
			:value="computeValue"
			:class="{'float-right': (field.labelStyle=='justify'),
                    'requiredincomplete': requiredIncomplete,
            }"
			v-bind:style="{ 'display': (field.labelStyle=='justify'||field.labelStyle=='inline'?'inline':''), 'width': (field.labelStyle=='justify'||field.labelStyle=='inline'?'auto':'') }"
			readonly
		>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly', 'formresponse','viewAs'],
	data() {
		return {
			'viewinfo': false
		}
	},
	methods: {
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        }
    },
	watch: {
		computeValue: {
			deep: true,
			handler: function (total) {
				this.field.value = total;
			}
		}
	},
	computed: {
		computeValue() {
			var total = 0;
			if(this.formresponse){
				if('formresponse_data' in this.formresponse){
					this.formresponse.formresponse_data.pages.forEach((page , pindex) => {
						page.grid.forEach(row => {
							row.forEach(col => {
								col.fields.forEach(fielditem => {
									if(
										this.field.computesettings.valuesfrom == 'all' ||
										(
											this.field.computesettings.valuesfrom == 'page' &&
											this.field.computesettings.pages.indexOf(pindex) != -1
										) ||
										(
											this.field.computesettings.valuesfrom == 'fields' &&
											this.field.computesettings.fields.indexOf(fielditem.id) != -1
										)
									) {
										if(fielditem.type == 'number'){
											total += Number(fielditem.value);
										}
										// Map values for other value types
										if(fielditem.type == 'text' || fielditem.type == 'textarea' || fielditem.type == 'select'){
											if(fielditem.value == Number(fielditem.value)){
												total += Number(fielditem.value);
											}
										}
									}
								});
							});
						});
					});
				}
			}

			return total;
		},
        requiredIncomplete() {
        	return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0) 
            && this.field.required && !this.field.value && this.field.value !== 0;
        },
        hasInfo() {
        	if(this.field.info){
        		return true;
        	}
        	return false;
        }
	}
};
</script>
